// ワンタイム URL の回答画面から「ログインして送る」で来たことを示す印。
// 詳細画面の認証ガードが「セッション切れ」のトーストを出さない判定に使う
// （ログインしていない人を回答の詳細へ案内しているだけで、セッションは切れていない）。
const TOKEN_ENTRY_PARAM = "from=bcp_token";

/**
 * 「ログインして送る」の行き先。詳細画面のパス（answerRequestPath で作ったもの）があればそこへ直接
 * （未ログインなら既存のガードがログイン経由で戻す）。無効 URL は依頼が無くパスも無いので /login
 */
export const tokenLoginHref = (detailPath: string | null | undefined): string =>
  detailPath ? `${detailPath}?${TOKEN_ENTRY_PARAM}` : "/login";

/** 認証ガードに渡る URL（resolvedUrl 等）が、ワンタイム URL の画面からの導線か */
export const isBcpTokenEntry = (url: string): boolean => {
  const query = url.split("?")[1] ?? "";
  return query.split("&").includes(TOKEN_ENTRY_PARAM);
};

// 制御文字（U+0000〜U+001F・U+007F）。ブラウザはタブ・改行・復帰を URL から取り除いてから解決するので、
// "/\t//evil" は検査を通ったあとで "//evil"（プロトコル相対の外部 URL）になる
const CONTROL_CHARS = /[\u0000-\u001F\u007F]/;

/**
 * ログイン後の戻り先。自サイト内の相対パス（/ 始まり）だけ通し、それ以外は / にする（オープンリダイレクト対策）。
 * 制御文字を含む値は取り除いて通さず / に倒す（取り除いた後の形をもう一度検査し直す必要が無いように）
 */
export const safeRedirectPath = (value: unknown): string => {
  if (typeof value !== "string" || !value.startsWith("/")) return "/";
  if (CONTROL_CHARS.test(value)) return "/";
  if (value.startsWith("//") || value.startsWith("/\\")) return "/";
  return value;
};
